module.exports = __webpack_public_path__ + "media/icons/opony-letnie-green@2x-9843cb24.png";